import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// ---Third-party imports
import React from 'react';
import clsx from 'clsx';
import { Dropdown, Popup, Menu, Image, Checkbox } from 'semantic-ui-react';
// ---Framework imports
import { Actions, Sel } from 'uix/registries';
import { XPopup } from 'uix/components';
import { useGraphics, useSelector, useState, useMemo, useActions } from 'uix/hooks';
import { sortBy, find, dict, get, values } from 'ldash';
import log from 'uix/logging';
import { differenceInDays, differenceInMonths, differenceInYears, addMonths, subMonths, addYears, getDate, getMonth, getYear, getDecade, getDaysInMonth, isAfter, formatDate } from 'uix/utils/date';
import { VIcon } from 'uix/graphics';
import { Graphics } from 'uix/graphics';
// ---Local imports
import S from './timeline.css';
import { wcUrl, ViewerLink } from './utils';
import { S2WP_DATA as DATA } from './testdata';
// TODO: need of string to date?
let RANGES = [
    {
        title: 'Test',
        startDate: '1892-06-02',
        endDate: '1902-09-02',
        color: 'blue'
    },
    {
        title: 'Professor',
        startDate: '1880-06-02',
        endDate: '1890-09-02',
        color: 'blue'
    },
    {
        title: 'Professor',
        startDate: '1882-06-02',
        endDate: '1890-09-02',
        color: 'white'
    }
];
const monthNames = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December'
];
const EventEntry = ({ date, title, position, stacking, pageWidth, pageHeight, pageId, eventIconSize, icon, color, type, text })=>{
    //--------HOOKS-------//
    let go = useActions(Actions.go);
    const apiurl = useSelector(Sel.apiurl);
    const i18n = useSelector(Sel.i18n);
    //------- Preparing PageImg -------///
    let maxPageHeight = 100;
    let maxPageWidth = 100;
    if (pageHeight > maxPageHeight) {
        pageWidth = Math.round(pageWidth * maxPageHeight / pageHeight);
        pageHeight = maxPageHeight;
    }
    if (pageWidth > pageHeight) {
        pageHeight = Math.round(pageHeight * maxPageWidth / pageWidth);
        pageWidth = maxPageWidth;
    }
    let pageImg = {
        width: pageWidth,
        height: pageHeight,
        backgroundPosition: 'center',
        minWidth: pageWidth,
        minHeight: pageHeight,
        transform: 'scale(0.75)'
    };
    //------- -------///
    let eventStyle = {
        left: `${position - 3.5}%`,
        bottom: `${stacking}px`,
        height: `${eventIconSize + 2}px`,
        width: `${eventIconSize + 2}px`
    };
    let iconStyle = {
        fontSize: `${eventIconSize}px`
    };
    let typeIcon = type && `md_${type}`;
    let iconName = !typeIcon ? icon : typeIcon;
    return /*#__PURE__*/ _jsx(XPopup, {
        fitted: true,
        basic: true,
        size: 'mini',
        on: 'click',
        position: 'top right',
        style: {
            padding: 0
        },
        trigger: /*#__PURE__*/ _jsx("div", {
            style: eventStyle,
            className: clsx(S.events, S[color]),
            children: /*#__PURE__*/ _jsx(VIcon, {
                style: iconStyle,
                name: iconName
            })
        }),
        children: /*#__PURE__*/ _jsx(Popup.Content, {
            className: S.popUp,
            children: /*#__PURE__*/ _jsxs(ViewerLink, {
                id: pageId,
                children: [
                    pageId && /*#__PURE__*/ _jsx("div", {
                        className: S.page,
                        children: /*#__PURE__*/ _jsx("img", {
                            style: pageImg,
                            src: `${wcUrl(apiurl, 304, pageId)}`
                        })
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: S.content,
                        children: [
                            /*#__PURE__*/ _jsx("div", {
                                className: S.date,
                                children: formatDate(new Date(date), 'dd.MM.yyyy')
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: S.title,
                                children: [
                                    title,
                                    text
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
};
let CATEGORIES = {
    cat1: {
        name: 'cat1',
        color: 'blue',
        label: 'foto'
    },
    cat2: {
        name: 'cat2',
        color: 'green',
        label: 'bla'
    }
};
export const Timeline = ({ ranges = RANGES, data = DATA, categories = CATEGORIES, ...props })=>{
    let [granularity, setGranularity] = useState('decades');
    let [filterRed, setFilterRed] = useState(false);
    let [filterWhite, setFilterWhite] = useState(false);
    let [filterBlue, setFilterBlue] = useState(false);
    let [stackHeight, setStackHeight] = useState(0);
    let initialActiveCats = dict(values(categories).map((cat)=>[
            cat.name,
            cat.active
        ]));
    let [activeCategories, setActiveCategories] = useState(initialActiveCats);
    let [newRanges, setNewRanges] = useState(ranges);
    if (props.granularity) {
        granularity = props.granularity;
    }
    const ColorToggle = ()=>{
        let smaller = {
            transformOrigin: 'right',
            transform: 'scale(0.8)',
            marginRight: '-1rem'
        };
        let cbs = values(categories).map((cat)=>/*#__PURE__*/ _jsx(Checkbox, {
                style: smaller,
                toggle: true,
                checked: activeCategories[cat.name],
                className: cat.color,
                onChange: (e, data)=>setActiveCategories({
                        ...activeCategories,
                        [cat.name]: data.checked
                    }),
                label: cat.label
            }, cat.name));
        return /*#__PURE__*/ _jsx("div", {
            className: S.filterArea,
            children: cbs
        });
    };
    const GranularOption = ()=>{
        let value = [];
        const granularOption = [
            {
                key: 1,
                text: 'Decades',
                value: 'decades'
            },
            {
                key: 2,
                text: 'Years',
                value: 'years'
            },
            {
                key: 3,
                text: 'Months',
                value: 'months'
            }
        ];
        return /*#__PURE__*/ _jsx(Dropdown, {
            compact: true,
            options: granularOption,
            onChange: (e, { value })=>setGranularity(value),
            placeholder: "Granularity"
        });
    };
    //----- Sort & filter Dates ----- //
    const sortedDates = sortBy(data, (date)=>date.date);
    const filteredDates = sortedDates.filter((date)=>activeCategories[date.category]);
    const sortedRanges = sortBy(ranges, (startDate)=>startDate.startDate);
    const updatedRanges = sortedRanges.filter((date)=>activeCategories[date.category]);
    //------Find Max, Min and Diff------//
    let dateMin = new Date(sortedDates[0].date);
    let dateMax = new Date(sortedDates[sortedDates.length - 1].date);
    let timeDiffMonth = differenceInMonths(dateMax, dateMin);
    let timeDiffDays = differenceInDays(dateMin, dateMax);
    let timeDiffYears = differenceInYears(dateMax, dateMin);
    let timeSpanArray = [];
    let timeDimension = 0;
    let timelineStart = getDecade(dateMin) // TODO:  Abhängig von Granularity
    ;
    let timelineEnd = getDecade(addYears(dateMax, 10)) // TODO:  Abhängig von Granularity
    ;
    let timelineSpan = timelineEnd - timelineStart;
    let prevEndDate = new Date('0-0-0');
    let topPosition = 1;
    let stackCount = 0;
    let eventIconSize = 13;
    let timeRange = updatedRanges.map(({ startDate, endDate, title, category }, i)=>{
        let startPoint = 100 * (getYear(new Date(startDate)) - timelineStart) / timelineSpan;
        let durration = 100 * (getYear(new Date(endDate)) - getYear(new Date(startDate))) / timelineSpan;
        let color = category;
        if (category) {
            color = categories[category].color;
        }
        let overlapping = isAfter(prevEndDate, new Date(startDate));
        overlapping ? topPosition = topPosition + 1.4 : topPosition = 0.5;
        prevEndDate = new Date(endDate);
        let timeRangeStyle = {
            left: `${startPoint}%`,
            width: `${durration}%`,
            top: `${topPosition}rem`
        };
        return /*#__PURE__*/ _jsx("div", {
            className: clsx(S.timeRange, S[color]),
            style: timeRangeStyle,
            children: /*#__PURE__*/ _jsx("span", {
                children: title
            })
        }, i);
    });
    //------Prepare Granularity & TimeSteps------//
    if (granularity == 'years') {
        timeSpanArray = [
            ...Array(timeDiffYears + 1)
        ];
    } else {
        timeSpanArray = [
            ...Array(timeDiffMonth + 1)
        ];
    }
    if (granularity == 'decades') {
        timeSpanArray = [
            ...Array(Math.round(timeDiffYears / 10))
        ];
    }
    //------Create Timesteps according granularity  ------//
    let timeStep = timeSpanArray.map((e, i)=>{
        let indicator = '';
        let startPoint = '';
        if (granularity == 'months') {
            indicator = monthNames[getMonth(addMonths(dateMin, i))];
            startPoint = format(addMonths(dateMin, i), 'yyyy-MM');
            timeDimension = getDaysInMonth(addMonths(dateMin, i)); // 30 Days one TimeStep
        } else {
            if (granularity == 'years') {
                startPoint = format(addYears(dateMin, i), 'yyyy');
                indicator = getYear(addYears(dateMin, i));
                timeDimension = 12; // 12 Months one TimeStep
            } else {
                if (granularity == 'decades') {
                    startPoint = getDecade(addYears(dateMin, 10 * i));
                    indicator = getDecade(addYears(dateMin, i * 10));
                    timeDimension = 10; // 10 Years one TimeStep
                } else indicator = 'fail';
            }
        }
        let position = 0;
        let lastPosition = 0;
        let stacking = `${eventIconSize + 2}`;
        let stack = 1;
        //------assign dates to Timesteps ------//
        // const entriesInMonth = filter(d, date => date.date.startsWith(startPoint))
        let event = filteredDates.map(({ date, pageHeight, pageWidth, pageId, title, type, icon, category, text }, z)=>{
            let color = category;
            if (category) {
                color = categories[category].color;
            }
            let formatedDate = '';
            if (granularity == 'months') {
                formatedDate = format(new Date(date), 'yyyy-MM');
            } else {
                formatedDate = format(new Date(date), 'yyyy');
            }
            if (granularity == 'decades' && formatedDate >= startPoint && formatedDate < startPoint + 10) {
                position = Math.round(100 * (formatedDate - startPoint) / timeDimension * 10) / 10;
                ///---- avoid hiding of icon ----///
                position > 90 && (position = position - 10);
                ///---- stack icons ----///
                if (position == lastPosition) {
                    stacking = stacking + eventIconSize + 2;
                    stack = stack + 1;
                    lastPosition = position;
                    if (stack > stackHeight) {
                        setStackHeight(stack);
                    }
                } else {
                    lastPosition = position;
                    stacking = eventIconSize + 2;
                    stack = 0;
                }
                return /*#__PURE__*/ _jsx(EventEntry, {
                    eventIconSize: eventIconSize,
                    date: date,
                    title: title,
                    position: position,
                    stacking: stacking,
                    pageWidth: pageWidth,
                    pageHeight: pageHeight,
                    pageId: pageId,
                    icon: icon,
                    color: color,
                    type: type,
                    text: text
                }, `${z}_${pageId}_${date}`);
            }
            if ((granularity == 'months' || granularity == 'years') && startPoint == formatedDate) {
                //------Calculate Position in TimeStep------//
                if (granularity == 'months') {
                    position = Math.round(100 * getDate(new Date(date)) / timeDimension / 10) * 10;
                } else {
                    if (granularity == 'years') {
                        position = Math.round(100 * getMonth(new Date(date)) / timeDimension / 20) * 20;
                    }
                }
                ///---- avoid hiding of icon ----///
                position > 90 && (position = position - 10);
                ///---- stack icons ----///
                if (position == lastPosition) {
                    stacking = stacking + 14;
                } else {
                    lastPosition = position;
                    stacking = 12;
                    stack = 0;
                }
                return /*#__PURE__*/ _jsx(EventEntry, {
                    date: date,
                    title: title,
                    position: position,
                    stacking: stacking,
                    pageWidth: pageWidth,
                    pageHeight: pageHeight,
                    pageId: pageId,
                    type: type,
                    icon: icon
                }, z);
            }
        });
        return /*#__PURE__*/ _jsxs("div", {
            className: S.timeStep,
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: S.stepDivider,
                    id: S.start
                }),
                event,
                /*#__PURE__*/ _jsx("div", {
                    className: S.indicator,
                    children: indicator
                }),
                i == timeSpanArray.length - 1 && /*#__PURE__*/ _jsxs("div", {
                    className: clsx(S.indicator, S.last),
                    children: [
                        " ",
                        indicator + 10,
                        " "
                    ]
                })
            ]
        }, i);
    });
    let stepHeight = {
        height: `${eventIconSize * stackHeight + 180}px`
    };
    //------Render TimeStep Div------//
    return /*#__PURE__*/ _jsxs("div", {
        className: S.container,
        children: [
            !props.granularity && /*#__PURE__*/ _jsx(GranularOption, {}),
            /*#__PURE__*/ _jsx(ColorToggle, {}),
            /*#__PURE__*/ _jsxs("div", {
                className: S.timelineWrapper,
                style: stepHeight,
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: S.timeline,
                        children: [
                            /*#__PURE__*/ _jsx("div", {
                                className: S.line
                            }),
                            timeStep
                        ]
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: S.timeRangeWrapper,
                        children: timeRange
                    })
                ]
            })
        ]
    });
};
